import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import Footer from '../components/Footer';
import Unauth from '../components/Unauth';
import { CurrentUser } from '../contexts/CurrentUser';
import { useContext } from 'react';

import { ROUTES } from '../utils/navigation';

function Home() {
    const { isLoggedIn } = useContext(CurrentUser);
    if (!isLoggedIn) {
        return <Unauth/>
    }

    return (
        <Container className='home-page'>
            <Row className='sub-title'>
                <Col>
                <h2>Welcome!</h2>
                    <p>The previous forum had to be retired and is no longer available.  However,
                        we did not want our members to lose out on the discussions, links, and
                        attached materials we've built up as a community over the years.
                    </p>
                    <p>To ensure our users have continued access to these resources we are
                        providing this tool.  Some new features have been introduced to help
                        you search through these archives and follow the conversations.
                    </p>
                    <p>Please let us know if you have any questions or suggestions.</p>
                </Col>
            </Row>
            <Row>
                <Carousel className='carousel-container'>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/search-layout.png"
                            alt='Search for posts'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Search the Archives
                            </h3>
                            <p>The archives have been indexed and now have full text search!</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/search-types.png"
                            alt='Narrow your search'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Narrow it down
                            </h3>
                            <p>You can select to search by forum name, subject, user, and more</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/search-by-date.png"
                            alt='Search by date'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Search by Date
                            </h3>
                            <p>If you know a conversation happened within a timeframe - search by date</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/attachments.png"
                            alt='Search by attachments'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Get attached
                            </h3>
                            <p>Need to find a specific .pdf or .doc?  Search by attachments</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/forum-list.png"
                            alt='List Forums'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                See all the forums
                            </h3>
                            <p>You can also list the forums and filter by the forum you need</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/topic-list.png"
                            alt='See topics in a forum'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Get on Topic
                            </h3>
                            <p>Each forum's topic list is available to filter or browse</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="carousel-image"
                            src="/assets/images/topic-thread.png"
                            alt='Follow the conversation'
                        />
                        <Carousel.Caption className='caption-area'>
                            <h3>
                                Follow the conversation
                            </h3>
                            <p>Each conversation on a topic is listed in the order originally posted in the old forum</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
            </Row>
            <Footer/>
        </Container>
    );
}

export default Home;